import { render, staticRenderFns } from "./MailPending.vue?vue&type=template&id=07c3387a&scoped=true&"
import script from "./MailPending.vue?vue&type=script&lang=ts&"
export * from "./MailPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3387a",
  null
  
)

export default component.exports